var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocial = function SvgSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2 12.5a2 2 0 0 1 2-2 3 3 0 0 1 3 3v4a3 3 0 0 1-3 3 2 2 0 0 1-2-2zM15.48 7.807l-.267.86c-.218.704-.327 1.057-.243 1.335.068.225.217.42.42.547.25.158.63.158 1.39.158h.404c2.57 0 3.855 0 4.462.76q.105.132.184.277c.467.848-.063 1.992-1.125 4.278-.974 2.097-1.462 3.146-2.366 3.764q-.132.09-.27.168c-.952.546-2.132.546-4.492.546h-.512c-2.858 0-4.288 0-5.176-.86C7 18.78 7 17.394 7 14.624v-.973c0-1.456 0-2.184.26-2.85.258-.666.752-1.214 1.742-2.31l4.09-3.93a3 3 0 0 1 .2-.21 1.033 1.033 0 0 1 1.443.092c.04.044.083.107.17.233.135.196.202.295.261.392.528.272.687.907.446 1.69-.027.11-.064.226-.133 1.049"
  })));
};
export default SvgSocial;